const firebaseConfig = {
    apiKey: "AIzaSyDoRdsrmL_pZJTT4HsAvtmjZ5bPmDGnFW8",
    authDomain: "utsabd-official-website.firebaseapp.com",
    databaseURL: "https://utsabd-official-website.firebaseio.com",
    projectId: "utsabd-official-website",
    storageBucket: "utsabd-official-website.appspot.com",
    messagingSenderId: "529954642939",
    appId: "1:529954642939:web:a0d449738ae9740f11095e"
  };
  export default firebaseConfig